import { isNumber, toLower } from "./string";
export const tableSort = (list = [], sortFilters) => {
    return sort(list, sortFilters.key, sortFilters.direction === "ASC" ? 1 : sortFilters.direction === "DESC" ? -1 : 0);
};
export const sort = (list = [], field, direction = 1) => {
    return !!list
        ? list.sort((a, b) => (a[field] < b[field] ? -direction : a[field] > b[field] ? direction : 0))
        : [];
};
export const compare = (val1, val2, direction = 1, secondarySort = (val1, val2) => 0) => {
    if (isNumber(val1) && isNumber(val2)) {
        return val1 < val2 ? -direction : val1 > val2 ? direction : secondarySort(val1, val2);
    }
    if (isNumber(val1)) {
        return direction;
    }
    else if (isNumber(val2)) {
        return -direction;
    }
    else {
        return val1 < val2 ? -direction : val1 > val2 ? direction : secondarySort(val1, val2);
    }
};
export const sortWithFunction = (list = [], field, direction = 1, manipulationFunc = (a) => a, secondarySort = () => 0) => list
    .map((a) => a)
    .sort((a, b) => {
    const val1 = manipulationFunc(a[field]);
    const val2 = manipulationFunc(b[field]);
    return compare(val1, val2, direction, secondarySort);
});
export const sortLabel = (a, b) => {
    const label1 = toLower(a.label);
    const label2 = toLower(b.label);
    return compare(label1, label2);
};
//# sourceMappingURL=SortUtil.js.map